  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
  import { NavLink }                                         from "react-router-dom";
  import cx                                                  from "classnames";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import AppBar                                              from "@material-ui/core/AppBar";
  import Toolbar                                             from "@material-ui/core/Toolbar";
//import Hidden                                              from "@material-ui/core/Hidden";
  import Drawer                                              from '@material-ui/core/Drawer';
  import List                                                from '@material-ui/core/List';
  import Divider                                             from '@material-ui/core/Divider';
  import ListItem                                            from '@material-ui/core/ListItem';
//import ListItemIcon                                        from '@material-ui/core/ListItemIcon';
  import ListItemText                                        from '@material-ui/core/ListItemText';
  import Typography                                          from '@material-ui/core/Typography';
  import Link                                                from '@material-ui/core/Link';
  //------------------
  // Custom components
  //------------------
//import AdminNavbarLinks                                    from "../AdminNavbarLinks/AdminNavbarLinks";
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import Button                                              from "components/CustomButtons/Button.jsx";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../../_helpers";
  import { wu_Utilities }                                    from "../../../_services";
  import { wu_LoginLogoutService }                           from "../../../_services";
  import { wu_StaticDataService }                            from "../../../_services";
  import { api }                                             from "../../../_constants";
  //----------
  // Libraries
  //----------
  import Cookies                                             from 'js-cookie';
  //------
  // Style
  //------
  import adminNavbarStyle                                    from "./adminNavbarStyle.jsx";
  //-------
  // images
  //-------
  import MenuIcon                                            from '@material-ui/icons/Menu';
  import CloseIcon                                           from '@material-ui/icons/Close';
//import ArrowRightIcon                                      from '@material-ui/icons/ArrowRight';
//import InboxIcon                                           from '@material-ui/icons/MoveToInbox';
//import MailIcon                                            from '@material-ui/icons/Mail';


  // width="341px" height="81px"
  // width="295px" height="70px"
  // width="253px" height="60px"
  // width="232px" height="55px"
  // width="211px" height="50px"
  // width="170px" height="41px"
  // width="141px" height="35px"
  // width="121px" height="30px"
import logoL_el                                            from "assets/img/wu/logo.svg";
import logoL_en                                            from "assets/img/wu/logo.svg";
  // import logoL_el                                            from "assets/img/wu/logo_30_el.svg";
  // import logoL_en                                            from "assets/img/wu/logo_30_en.svg";

  //0 0 318 99
  //0 0 257 80
  //0 0 193 60
  import logoRdesktop                                        from "assets/img/wu/wu-bg-alternate-logo-gray2.svg";
  import logoRdesktop_bp                                     from "assets/img/wu/wu-bg-alternate-logo-gray2_bp.svg";

  //0 0 124.67 70.39
  //import logoRmobile                                         from "assets/img/wu/wu-bg-alternate-logo-gray2-mobile1.svg";
  //viewBox="0 0 93.07 51.82"
  import logoRmobile                                         from "assets/img/wu/wu-bg-alternate-logo-gray2-mobile2.svg";

  var rightLogoGridStyleMobile_wu = {
    backgroundImage       : `url(${logoRmobile})`,
    height                : "80px",
  //width                 : "100%",
    backgroundPosition    : 'center',
    backgroundSize        : 'cover',
    backgroundRepeat      : 'no-repeat',
    padding               : "0px !important",
    margin                : "0px !important",
  };
  var rightLogoGridStyleMobile_bp = {
  //backgroundImage       : `url(${logoRmobile})`,
    backgroundColor       : "rgba(95,95,95,1)",
    height                : "80px",
  //width                 : "100%",
    backgroundPosition    : 'center',
    backgroundSize        : 'cover',
    backgroundRepeat      : 'no-repeat',
    padding               : "0px !important",
    margin                : "0px !important",
  };
  var rightLogoGridStyleDesktop_wu = {
  //backgroundImage       : `url(${logoRdesktop})`,
    height                : "80px",
  //width                 : "100%",
    // backgroundPosition    : 'center',
    // backgroundSize        : 'cover',
    // backgroundRepeat      : 'no-repeat',
    padding               : "0px !important",
    margin                : "0px !important",

    backgroundColor       : "rgba(251,217,0,1)",
  };
  var rightLogoGridStyleDesktop_bp = {
  //backgroundImage       : `url(${logoRdesktop})`,
    height                : "80px",
  //width                 : "100%",
    // backgroundPosition    : 'center',
    // backgroundSize        : 'cover',
    // backgroundRepeat      : 'no-repeat',
    padding               : "0px !important",
    margin                : "0px !important",

    backgroundColor       : "rgba(95,95,95,1)",
  };

  var drawerIsOpen = false;

const filename = "Admin ";

class AdminNavbar extends React.Component {
// function AdminNavbar({ ...props }) {
//   const { classes, color, brandText } = props;
//   const appBarClasses = cx({
//     [" " + classes[color]]: color
//   });
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    super(props);

    console.log("window.innerHeight="+window.innerHeight);
    let listItemHeight_TMP       = "36px";
    let listItemTextFontSize_TMP = "14px";
    if(                           window.innerHeight<500) { listItemHeight_TMP = "36px"; listItemTextFontSize_TMP = "14px";}
    if(window.innerHeight>500  && window.innerHeight<600) { listItemHeight_TMP = "36px"; listItemTextFontSize_TMP = "14px";} //5
    if(window.innerHeight>600  && window.innerHeight<700) { listItemHeight_TMP = "36px"; listItemTextFontSize_TMP = "14px";} //6
    if(window.innerHeight>700  && window.innerHeight<800) { listItemHeight_TMP = "36px"; listItemTextFontSize_TMP = "14px";} //6 plus
    if(window.innerHeight>800  && window.innerHeight<900) { listItemHeight_TMP = "36px"; listItemTextFontSize_TMP = "14px";} //X
    if(window.innerHeight>900  && window.innerHeight<1000){ listItemHeight_TMP = "36px"; listItemTextFontSize_TMP = "14px";}
    if(window.innerHeight>1000 && window.innerHeight<1100){ listItemHeight_TMP = "36px"; listItemTextFontSize_TMP = "14px";}//iPad
    if(window.innerHeight>1100 && window.innerHeight<1200){ listItemHeight_TMP = "36px"; listItemTextFontSize_TMP = "14px";}
    //iPhone5    ->320x568->font=14px,height=38.4
    //iPhone6/7/8->375x667->font=14px,height=38.4
    //iPhone6/7/8->414x736->font=14px,height=38.4
    //iPhoneX    ->375x812->font=14px,height=38.4
    //iPad       ->375x812->font=14px,height=38.4

    this.state = {
      openAvatar                                 : false,
      miniActive                                 : true,
      drawerIsOpen                               : false,
      marginTopDivDrawer                         : 80,

      leftLogoW                                  : "210px",
      leftLogoH                                  : "70px",
      leftLogoW_mobile                           : "157px", //75%
      leftLogoH_mobile                           : "52px",

      marginTopDivNavLink                        : 28,
      marginTopDivLanguage                       : 28,

      rightLogoW                                 : "257px",
      rightLogoH                                 : "80px",

      listItemHeight                             : listItemHeight_TMP,
      listItemTextFontSize                       : listItemTextFontSize_TMP,
      ListItemShowDivider                        : false,
    };
    this.handleLogout_fromIconClick          = this.handleLogout_fromIconClick.bind(this);

    this.toggleDrawer                        = this.toggleDrawer.bind(this);
    this.openCloseDrawer_act                 = this.openCloseDrawer_act.bind(this);

    this.handleListItemClick_Bills           = this.handleListItemClick_Bills.bind(this);
    this.handleListItemClick_TransferOnline1 = this.handleListItemClick_TransferOnline1.bind(this);
    this.handleListItemClick_TrackTransfer   = this.handleListItemClick_TrackTransfer.bind(this);
    this.handleListItemClick_StoreLocator    = this.handleListItemClick_StoreLocator.bind(this);
    this.handleListItemClick_More            = this.handleListItemClick_More.bind(this);
    this.handleListItemClick_Services        = this.handleListItemClick_Services.bind(this);
    this.handleListItemClick_HistoryList     = this.handleListItemClick_HistoryList.bind(this);
    this.handleListItemClick_SettingsMain    = this.handleListItemClick_SettingsMain.bind(this);
    this.handleListItemClick_RegisterLight1  = this.handleListItemClick_RegisterLight1.bind(this);
    this.handleListItemClick_SettingsHelp    = this.handleListItemClick_SettingsHelp.bind(this);
    this.handleListItemClick_LoginPage       = this.handleListItemClick_LoginPage.bind(this);
    this.handleListItemClick_EN              = this.handleListItemClick_EN.bind(this);
    this.handleListItemClick_GR              = this.handleListItemClick_GR.bind(this);
  }

  toggleDrawer(side,status){
    //this.setState({drawerIsOpen: status});
  }
  openCloseDrawer_act(status){
    status.stopPropagation();
    console.log(status);
    this.setState({drawerIsOpen:!this.state.drawerIsOpen});
    drawerIsOpen=!this.state.drawerIsOpen;
    // setTimeout(()=>{
    //   if(drawerIsOpen){
    //     document.getElementsByClassName("MuiDrawer-paperAnchorTop")[0].style.top="80px";
    //     Array.from(document.getElementsByClassName("MuiBackdrop-root")).forEach((item, i) => {
    //       item.style.top="80px";
    //     });
    //     //document.getElementsByClassName("MuiDrawer-root")[0].style.top="80px";
    //   }
    // },200);
  }

  render() {
    const { classes, color } = this.props;
    const appBarClasses = cx({
      [" " + classes[color]]: color
    });

    return (
      <div>
      <AppBar position="absolute" className={classes.appBar + appBarClasses} color="primary" id="menisAppBarId">
        <Toolbar className={classes.container}  id="menisToolbarId">
          {/* -------------------------------------------------- */}
          {/* ----------isLoggedIn=TRUE------------------------- */}
          {/* -------------------------------------------------- */}
          {localStorage.getItem("isLoggedIn")!=="true" ? ( "" ) : (
            <GridContainer justify="center" className={classes.GridContainerLocal}>
                {this.props.mobile===true ?(
                  <React.Fragment>
                    <GridItem xs={6} sm={6} md={6} className={classes.GridItemLocal}>
                      <div id="scrollHereHeader" className={classes.leftLogoStyleMobile}>
                        <Link onClick={(event) => this.handleLogout_fromIconClick(event)}><img width={this.state.leftLogoW_mobile} height={this.state.leftLogoH_mobile} align="left" src={this.getLogoL()} alt=""/></Link>
                      </div>
                    </GridItem>
                  </React.Fragment>
                ) :
                (
                  <React.Fragment>
                    <GridItem xs={2} sm={2} md={2} className={classes.GridItemLocal}>
                      <div id="scrollHereHeader" className={classes.leftLogoStyle}>
                        <Link onClick={(event) => this.handleLogout_fromIconClick(event)}><img width={this.state.leftLogoW} height={this.state.leftLogoH} align="left" src={this.getLogoL()} alt=""/></Link>
                      </div>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={8} className={classes.GridItemLocal}>
                      <div style={{ marginTop:this.state.marginTopDivNavLink, "textAlign":"right" }}>
                        <NavLink
                          className={classes.AdminNavLink}
                          to={wu_Utilities.getNavigationURLs("Bills")}
                          activeStyle={{ color:'#FFDD00'}}
                          justify="center">
                          {NSInforString("Header_Bills")}
                        </NavLink>
                        <NavLink
                          className={classes.AdminNavLink}
                          to={wu_Utilities.getNavigationURLs("TransferOnline1")}
                          activeStyle={{ color:'#FFDD00'}}
                          justify="center">
                          {NSInforString("Header_TransferOnline")}
                        </NavLink>
                        {/* <NavLink
                          className={classes.AdminNavLink}
                          to={wu_Utilities.getNavigationURLs("TrackTransfer")}
                          activeStyle={{ color:'FFDD00'}}
                          justify="center">
                          {NSInforString("Header_TrackTransfer")}
                        </NavLink> */}
                        <NavLink
                          className={classes.AdminNavLink}
                          to={wu_Utilities.getNavigationURLs("StoreLocator")}
                          activeStyle={{ color:'FFFFFF'}}
                          justify="center">
                          {NSInforString("Header_StoreLocator")}
                        </NavLink>
                        {/* <NavLink
                          className={classes.AdminNavLink}
                          to={wu_Utilities.getNavigationURLs("HistoryList")}
                          activeStyle={{ color:'FFFFFF'}}
                          justify="center">
                          {NSInforString("Header_History")}
                        </NavLink> */}
                        <NavLink
                          className={classes.AdminNavLink}
                          to={wu_Utilities.getNavigationURLs("SettingsMain")}
                          activeStyle={{ color:'FFFFFF'}}
                          justify="center">
                          {NSInforString("Header_Profile")}
                        </NavLink>
                        <NavLink
                          className={classes.AdminNavLink}
                          to={wu_Utilities.getNavigationURLs("More")}
                          activeStyle={{ color:'FFFFFF'}}
                          justify="center">
                          {NSInforString("Header_More")}
                        </NavLink>
                        &nbsp;&nbsp;
                        <Button className={classes.serviceshelpbutton} id="Help" value="Help" onClick={(event) => this.props.rerenderParentCallbackLogoutAndSite("HELP")} color="primary">{NSInforString("Header_Help")}</Button>
                        &nbsp;&nbsp;
                        |
                        &nbsp;&nbsp;
                        <Button className={classes.langbutton} id="Logout" value="Logout" onClick={(event) => this.props.rerenderParentCallbackLogout("logout")} color="primary">{NSInforString("Header_logout")}</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Button className={classes.langbutton} id="EN" value="EN" onClick={(event) => this.props.rerenderParentCallback("en")} color="primary">EN</Button> | <Button className={classes.langbutton} id="GR" value="GR" onClick={(event) => this.props.rerenderParentCallback("el")} color="primary">GR</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </div>
                    </GridItem>
                  </React.Fragment>
                )}
                {this.props.mobile===true ? (
                  <GridItem xs={6} sm={6} md={6} style={ this.getRightLogoGridStyleMobile() }>
                      <div align="right">
                        <Button
                          className={classes.menuButtonClassY}
                          justIcon
                          aria-label="open drawer"
                          onClick={this.openCloseDrawer_act}
                        >
                          {drawerIsOpen ? ( <CloseIcon/> ) : ( <MenuIcon/> )}
                        </Button>
                      </div>
                  </GridItem>
                ) :
                (
                  <GridItem xs={2} sm={2} md={2} style={ this.getRightLogoGridStyleDesktop() }>
                    <img src={this.getLogoRdesktop()} style={{"marginLeft":"-16px", height:"80px", width:"211px"}} alt=""/>
                  </GridItem>
                )}
            </GridContainer>
          )}
          {/* -------------------------------------------------- */}
          {/* ----------isLoggedIn=FALSE------------------------ */}
          {/* -------------------------------------------------- */}
          {localStorage.getItem("isLoggedIn")==="true" ? ( "" ) : (
            <GridContainer justify="center" className={classes.GridContainerLocal}>
                {this.props.mobile===true ?(
                  <React.Fragment>
                    <GridItem xs={6} sm={6} md={6} className={classes.GridItemLocal}>
                      <div id="scrollHereHeader" className={classes.leftLogoStyleMobile}>
                        <a href={this.getHomePageURL()}><img width={this.state.leftLogoW_mobile} height={this.state.leftLogoH_mobile} align="left" src={this.getLogoL()} alt=""/></a>
                      </div>
                    </GridItem>
                  </React.Fragment>
                ) :
                (
                  <React.Fragment>
                    <GridItem xs={2} sm={2} md={2} className={classes.GridItemLocal}>
                      <div id="scrollHereHeader" className={classes.leftLogoStyle}>
                        <a href={this.getHomePageURL()}><img width={this.state.leftLogoW} height={this.state.leftLogoH} align="left" src={this.getLogoL()} alt=""/></a>
                      </div>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={8} className={classes.GridItemLocal}>
                      <div style={{ marginTop:this.state.marginTopDivNavLink, "textAlign":"right" }}>
                        <NavLink
                          className={classes.AdminNavLink}
                          to={wu_Utilities.getNavigationURLs("Bills")}
                          activeStyle={{ color:'#FFDD00'}}
                          justify="center">
                          {NSInforString("Header_Bills")}
                        </NavLink>
                        <NavLink
                          className={classes.AdminNavLink}
                          to={wu_Utilities.getNavigationURLs("TransferOnline1")}
                          activeStyle={{ color:'#FFDD00'}}
                          justify="center">
                          {NSInforString("Header_TransferOnline")}
                        </NavLink>
                        {/* <NavLink
                          className={classes.AdminNavLink}
                          to={wu_Utilities.getNavigationURLs("TrackTransfer")}
                          activeStyle={{ color:'FFDD00'}}
                          justify="center">
                          {NSInforString("Header_TrackTransfer")}
                        </NavLink> */}
                        <NavLink
                          className={classes.AdminNavLink}
                          to={wu_Utilities.getNavigationURLs("StoreLocator")}
                          activeStyle={{ color:'FFFFFF'}}
                          justify="center">
                          {NSInforString("Header_StoreLocator")}
                        </NavLink>
                        <NavLink
                          className={classes.AdminNavLink}
                          to={wu_Utilities.getNavigationURLs("More")}
                          activeStyle={{ color:'FFFFFF'}}
                          justify="center">
                          {NSInforString("Header_More")}
                        </NavLink>
                        &nbsp;
                        <Button className={classes.serviceshelpbutton} id="Services" value="Services" onClick={(event) => this.props.rerenderParentCallbackLogoutAndSite("SERVICES")} color="primary">{NSInforString("Header_Services")}</Button>
                        &nbsp;
                        <Button className={classes.serviceshelpbutton} id="Help" value="Help" onClick={(event) => this.props.rerenderParentCallbackLogoutAndSite("HELP")} color="primary">{NSInforString("Header_Help")}</Button>
                        &nbsp;
                        |
                        <NavLink
                          className={classes.AdminNavLink}
                          to={wu_Utilities.getNavigationURLs("LoginPage")}
                          activeStyle={{ color:'FFFFFF', fontSize:"12px",}}
                          justify="center">
                          {NSInforString("Header_login")}
                        </NavLink>
                        |
                        <NavLink
                          className={classes.AdminNavLink}
                          to={(api.new_registration_enabled) ? wu_Utilities.getNavigationURLs("RegisterLight1") : wu_Utilities.getNavigationURLs("RegisterLight1")}
                          activeStyle={{ color:'FFFFFF'}}
                          justify="center">
                          {NSInforString("Header_Register")}
                        </NavLink>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Button className={classes.langbutton} id="EN" value="EN" onClick={(event) => this.props.rerenderParentCallback("en")} color="primary">EN</Button> | <Button className={classes.langbutton} id="GR" value="GR" onClick={(event) => this.props.rerenderParentCallback("el")} color="primary">GR</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </div>
                    </GridItem>
                  </React.Fragment>
                )}
                {this.props.mobile===true ? (
                  <GridItem xs={6} sm={6} md={6} style={ this.getRightLogoGridStyleMobile() }>
                      <div align="right">
                        <Button
                          className={classes.menuButtonClassY}
                          justIcon
                          aria-label="open drawer"
                          onClick={this.openCloseDrawer_act}
                        >
                          {drawerIsOpen ? ( <CloseIcon/> ) : ( <MenuIcon/> )}
                        </Button>
                      </div>
                  </GridItem>
                ) :
                (
                  <GridItem xs={2} sm={2} md={2} style={ this.getRightLogoGridStyleDesktop() }>
                    <img src={this.getLogoRdesktop()} style={{"marginLeft":"-16px", height:"80px", width:"211px"}} alt=""/>
                  </GridItem>
                )}
            </GridContainer>
          )}
          {/*
          <Hidden smDown implementation="css">
            <AdminNavbarLinks />
          </Hidden>
          <div style={{ marginRight: 10 }}>
            <Hidden mdUp implementation="css">
              <Button
                className={classes.menuButtonClass}
                justIcon
                aria-label="open drawer"
                onClick={this.openCloseDrawer_act}
              >
                <MenuIcon/>
              </Button>
            </Hidden>
          </div>*/}
        </Toolbar>
      </AppBar>
      {localStorage.getItem("isLoggedIn")==="true" ?
      (
        <Drawer anchor="top" open={this.props.mobile && this.state.drawerIsOpen} onClose={this.toggleDrawer('top', false)} className={classes.drawer}>
         {
           <div
               style     = {{marginTop:this.state.marginTopDivDrawer}}
               className = {classes.fullList}
               role      = "presentation"
               onClick   = {this.toggleDrawer('top', false)}
               onKeyDown = {this.toggleDrawer('top', false)}
             >
               <List style = {{backgroundColor : "#5F5F5F"}}>
                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_EN} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_EN")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_GR} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_GR")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_Bills} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_Bills")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_TransferOnline1} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_TransferOnline")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 {/* <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_TrackTransfer} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_TrackTransfer")}</Typography>} />> */}
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 {/* </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )} */}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_StoreLocator} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_StoreLocator")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 {/* <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_HistoryList} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_History")}</Typography>} /> */}
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 {/* </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )} */}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_SettingsMain} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_Profile")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_More} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_More")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_Services} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_Services")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_SettingsHelp} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_Help")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_LoginPage} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_logout")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

               </List>
           </div>
         }
         </Drawer>
      )
       :
      (
        <Drawer anchor="top" open={this.props.mobile && this.state.drawerIsOpen} onClose={this.toggleDrawer('top', false)} className={classes.drawer}>
         {
           <div
               style     = {{marginTop:this.state.marginTopDivDrawer}}
               className = {classes.fullList}
               role      = "presentation"
               onClick   = {this.toggleDrawer('top', false)}
               onKeyDown = {this.toggleDrawer('top', false)}
             >
               <List style = {{backgroundColor : "#5F5F5F"}}>
                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_EN} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_EN")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_GR} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_GR")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_Bills} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_Bills")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_TransferOnline1} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_TransferOnline")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 {/* <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_TrackTransfer} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_TrackTransfer")}</Typography>} /> */}
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 {/* </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )} */}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_StoreLocator} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_StoreLocator")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_More} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_More")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_Services} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_Services")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_SettingsHelp} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_Help")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_LoginPage} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_login")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}

                 <ListItem style={{height:this.state.listItemHeight}} onClick={this.handleListItemClick_RegisterLight1} button>
                   <ListItemText disableTypography primary={<Typography type="body2" style={{ fontSize:this.state.listItemTextFontSize, color:'#FFFFFF' }}>{NSInforString("Header_Register")}</Typography>} />
                   {/* <ListItemIcon><ArrowRightIcon className={classes.ListItemIcon}/></ListItemIcon> */}
                 </ListItem>
                 {this.state.ListItemShowDivider === false ? ( "" ) : (<Divider /> )}
               </List>
           </div>
         }
         </Drawer>
       )}
      </div>

    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------ListItem Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_Bills(event){
    let methName = filename+"handleListItemClick_Bills ";
    console.log(methName);
    this.setState({drawerIsOpen:false});
    drawerIsOpen=false;
    //+++++++++++++++
    //TransferOnline1
    //+++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("Bills"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_TransferOnline1(event){
    let methName = filename+"handleListItemClick_TransferOnline1 ";
    console.log(methName);
    this.setState({drawerIsOpen:false});
    drawerIsOpen=false;
    //+++++++++++++++
    //TransferOnline1
    //+++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("TransferOnline1"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_TrackTransfer(event){
    let methName = filename+"handleListItemClick_TrackTransfer ";
    console.log(methName);
    this.setState({drawerIsOpen:false});
    drawerIsOpen=false;
    //+++++++++++++
    //TrackTransfer
    //+++++++++++++
    history.push(wu_Utilities.getNavigationURLs("TrackTransfer"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_StoreLocator(event){
    let methName = filename+"handleListItemClick_StoreLocator ";
    console.log(methName);
    this.setState({drawerIsOpen:false});
    drawerIsOpen=false;
    //++++++++++++
    //StoreLocator
    //++++++++++++
    history.push(wu_Utilities.getNavigationURLs("StoreLocator"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_More(event){
    let methName = filename+"handleListItemClick_More ";
    console.log(methName);
    this.setState({drawerIsOpen:false});
    drawerIsOpen=false;
    //++++++++++++
    //StoreLocator
    //++++++++++++
    history.push(wu_Utilities.getNavigationURLs("More"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_Services(event){
    let methName = filename+"handleListItemClick_Services ";
    console.log(methName);
    this.setState({drawerIsOpen:false});
    drawerIsOpen=false;
    //++++++++++++
    //StoreLocator
    //++++++++++++
    //history.go(this.getServicesURL());
    //window.location.href = this.getServicesURL();

    setTimeout(function() { //Start the timer
      //--------
      //wu_login
      //--------
      wu_LoginLogoutService
      .wu_logout()
      .then(res => {
        console.log("!!!!!!!!!!localStorage.setItem(isLoggedIn=false)-1!!!!!!!!!!");
        localStorage.setItem("isLoggedIn","false");
        Cookies.set('isLoggedInAtWebApp', 'false', { expires:1, path:'' });
        window.location.href = this.getServicesURL();
      })
      .catch(err => {
        //this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){
          //this.dialog_handleOpen(err.returnText);
        }
        //Force logout from Local Session if WS does not answer
        console.log("!!!!!!!!!!localStorage.setItem(isLoggedIn=false)-2!!!!!!!!!!");
        localStorage.setItem("isLoggedIn","false");
        window.location.href = this.getServicesURL();
      });
    }.bind(this), 100);
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_HistoryList(event){
    let methName = filename+"handleListItemClick_HistoryList ";
    console.log(methName);
    this.setState({drawerIsOpen:false});
    drawerIsOpen=false;
    //+++++++++++
    //HistoryList
    //+++++++++++
    history.push(wu_Utilities.getNavigationURLs("HistoryList"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_SettingsMain(event){
    let methName = filename+"handleListItemClick_SettingsMain ";
    console.log(methName);
    this.setState({drawerIsOpen:false});
    drawerIsOpen=false;
    //++++++++++++
    //SettingsMain
    //++++++++++++
    history.push(wu_Utilities.getNavigationURLs("SettingsMain"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_RegisterLight1(event){
    let methName = filename+"handleListItemClick_RegisterLight1 ";
    console.log(methName);
    this.setState({drawerIsOpen:false});
    //++++++++++++++
    //RegisterLight1
    //++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("RegisterLight1"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_SettingsHelp(event){
    let methName = filename+"handleListItemClick_SettingsHelp ";
    console.log(methName);
    this.setState({drawerIsOpen:false});
    drawerIsOpen=false;
    //++++++++++++
    //SettingsHelp
    //++++++++++++
    //history.push(wu_Utilities.getNavigationURLs("SettingsHelp"));
    //window.location.href = this.getHelpURL();
    window.open(this.getServicesURL(), "_blank");
    window.open(this.getServicesURL(), "_blank");
    //return;

    setTimeout(function() { //Start the timer
      //--------
      //wu_login
      //--------
      wu_LoginLogoutService
      .wu_logout()
      .then(res => {
        console.log("!!!!!!!!!!localStorage.setItem(isLoggedIn=false)-1!!!!!!!!!!");
        localStorage.setItem("isLoggedIn","false");
        Cookies.set('isLoggedInAtWebApp', 'false', { expires:1, path:'' });
        window.location.href = this.getHelpURL();
      })
      .catch(err => {
        //this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){
          //this.dialog_handleOpen(err.returnText);
        }
        //Force logout from Local Session if WS does not answer
        console.log("!!!!!!!!!!localStorage.setItem(isLoggedIn=false)-2!!!!!!!!!!");
        localStorage.setItem("isLoggedIn","false");
        window.location.href = this.getHelpURL();
      });
    }.bind(this), 100);
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_LoginPage(event){
    let methName = filename+"handleListItemClick_LoginPage ";
    console.log(methName);
    this.setState({drawerIsOpen:false});
    drawerIsOpen=false;
    //+++++++++
    //LoginPage
    //+++++++++
    history.push(wu_Utilities.getNavigationURLs("LoginPage"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_EN(event){
    let methName = filename+"handleListItemClick_EN ";
    console.log(methName);
    this.setState({drawerIsOpen:false});
    drawerIsOpen=false;

    this.props.rerenderParentCallback("en");
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick_GR(event){
    let methName = filename+"handleListItemClick_GR ";
    console.log(methName);
    this.setState({drawerIsOpen:false});
    drawerIsOpen=false;

    this.props.rerenderParentCallback("el");
  }

  getHelpURL(){
    // <NavLink
    //   className={classes.AdminNavLink}
    //   to={this.getHelpURL()}
    //   activeStyle={{ color:'#FFFFFF'}}
    //   justify="center">
    //   {NSInforString("Header_Help")}
    // </NavLink>
    //{/* to={wu_Utilities.getNavigationURLs("SettingsHelp")} */}
    if(localStorage.getItem("lang")==="en"){ return api.url_website+"/en/customer-service-themes/";}
    else                                   { return api.url_website+"/customer-service-gr/";}
  }
  getServicesURL(){
    if(localStorage.getItem("lang")==="en"){ return api.url_website+"/en/sending-receiving-cash/";}
  //else                                   { return api.url_website+"/western-union-worldwide-network/";}
    else                                   { return api.url_website+"/oi-ypiresies-mas/";}
  }
  getHomePageURL(){
    if(localStorage.getItem("lang")==="en"){ return api.url_website+"/en/";}
    else                                   { return api.url_website+"/";}
  }
  //----------------------------------------------------------------------------------------------------
  getLogoL(){
    let methName = filename+"getLogoL ";
    //if(api.print_logs){console.log(methName+props);}

    if(this.props.mobile === false){
      if(localStorage.getItem("lang")==="en"){ return logoL_en;}
      else                                   { return logoL_el;}
    }
    else{
      //console.log(methName+"this.props.location.pathname="+this.props.location.pathname);
      let currView = "";
      try{ currView = this.props.location.pathname; }catch(err){console.log(methName+'err='+err);}
      if([api.webapp_path+"/Bills", api.webapp_path+"/BillsCategories", api.webapp_path+"/BillsCompanies", api.webapp_path+"/BillsFavorites", api.webapp_path+"/BillsFavoritesDetail", api.webapp_path+"/BillsHistory", api.webapp_path+"/BillsHistoryDetail", api.webapp_path+"/BillsPaymentReview", api.webapp_path+"/BillsPaymentSetup"].includes(currView)){
        return logoRdesktop_bp;
      }
      else{
        if(localStorage.getItem("lang")==="en"){ return logoL_en;}
        else                                   { return logoL_el;}
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  getRightLogoGridStyleMobile(){
    let methName = filename+"getRightLogoGridStyleMobile ";
    //if(api.print_logs){console.log(methName+props);}

    //console.log(methName+"this.props.location.pathname="+this.props.location.pathname);
    let currView = "";
    try{ currView = this.props.location.pathname; }catch(err){console.log(methName+'err='+err);}
    if([api.webapp_path+"/Bills", api.webapp_path+"/BillsCategories", api.webapp_path+"/BillsCompanies", api.webapp_path+"/BillsFavorites", api.webapp_path+"/BillsFavoritesDetail", api.webapp_path+"/BillsHistory", api.webapp_path+"/BillsHistoryDetail", api.webapp_path+"/BillsPaymentReview", api.webapp_path+"/BillsPaymentSetup"].includes(currView)){
      return rightLogoGridStyleMobile_bp;
    }
    else{
      return rightLogoGridStyleMobile_wu;
    }
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  getLogoRdesktop(){
    let methName = filename+"getLogoRdesktop ";
    //if(api.print_logs){console.log(methName+props);}

    //console.log(methName+"this.props.location.pathname="+this.props.location.pathname);
    let currView = "";
    try{ currView = this.props.location.pathname; }catch(err){console.log(methName+'err='+err);}
    if([api.webapp_path+"/Bills", api.webapp_path+"/BillsCategories", api.webapp_path+"/BillsCompanies", api.webapp_path+"/BillsFavorites", api.webapp_path+"/BillsFavoritesDetail", api.webapp_path+"/BillsHistory", api.webapp_path+"/BillsHistoryDetail", api.webapp_path+"/BillsPaymentReview", api.webapp_path+"/BillsPaymentSetup"].includes(currView)){
      return logoRdesktop_bp;
    }
    else{
      return logoRdesktop;
    }
  }
  //----------------------------------------------------------------------------------------------------
  getRightLogoGridStyleDesktop(){
    let methName = filename+"getRightLogoGridStyleDesktop ";
    //if(api.print_logs){console.log(methName+props);}

    //console.log(methName+"this.props.location.pathname="+this.props.location.pathname);
    let currView = "";
    try{ currView = this.props.location.pathname; }catch(err){console.log(methName+'err='+err);}
    if([api.webapp_path+"/Bills", api.webapp_path+"/BillsCategories", api.webapp_path+"/BillsCompanies", api.webapp_path+"/BillsFavorites", api.webapp_path+"/BillsFavoritesDetail", api.webapp_path+"/BillsHistory", api.webapp_path+"/BillsHistoryDetail", api.webapp_path+"/BillsPaymentReview", api.webapp_path+"/BillsPaymentSetup"].includes(currView)){
      return rightLogoGridStyleDesktop_bp;
    }
    else{
      return rightLogoGridStyleDesktop_wu;
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleLogout_fromIconClick(event){
    let methName = filename+"handleLogout_FromIconClick ";
    console.log(methName);

    event.preventDefault();
    setTimeout(function() { //Start the timer
      //--------
      //wu_login
      //--------
      wu_LoginLogoutService
      .wu_logout()
      .then(res => {
        console.log("!!!!!!!!!!localStorage.setItem(isLoggedIn=false)-1!!!!!!!!!!");
        localStorage.setItem("isLoggedIn","false");
        Cookies.set('isLoggedInAtWebApp', 'false', { expires:1, path:'' });
        window.location.href = this.getHomePageURL();
      })
      .catch(err => {
        //this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){
          //this.dialog_handleOpen(err.returnText);
        }
        //Force logout from Local Session if WS does not answer
        console.log("!!!!!!!!!!localStorage.setItem(isLoggedIn=false)-2!!!!!!!!!!");
        localStorage.setItem("isLoggedIn","false");
        window.location.href = this.getHomePageURL();
      });
    }.bind(this), 100);
  }
  //----------------------------------------------------------------------------------------------------
}

AdminNavbar.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "blue",
    "TS_Main"
  ]),
  brandText: PropTypes.object
};

function NSInforString(aKey){
  let texts_gr = wu_StaticDataService.wu_getLocales_gr({});
  let texts_en = wu_StaticDataService.wu_getLocales_en({});
  if(localStorage.getItem("lang")==="en"){ return texts_en[aKey] ? texts_en[aKey] : ""; }
  else                                   { return texts_gr[aKey] ? texts_gr[aKey] : ""; }
};

export default withStyles(adminNavbarStyle)(AdminNavbar);
